import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export type BannerSubtypes = (typeof ALLOWED_BANNER_SUB_TYPE)[number]

export const ALLOWED_BANNER_SUB_TYPE = ['brand', 'campaign', 'member'] as const

export const BannerSubtypeValidation = z.object({
  value: z.enum(ALLOWED_BANNER_SUB_TYPE, {
    required_error: '[BannerSubtype]  value is required',
  }),
})

export class BannerSubtype extends Model {
  static create({ value }: z.infer<typeof BannerSubtypeValidation>) {
    BannerSubtypeValidation.parse({ value })
    return new BannerSubtype(value)
  }

  static createOrUndefined(value?: BannerSubtypes) {
    try {
      if (!value) return undefined

      return BannerSubtype.create({ value })
    } catch {
      return undefined
    }
  }

  constructor(private readonly _value: BannerSubtypes) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
